<!-- 防劫持帮助 -->
<template>
    <div class="hijackingHelp">
        <div class="titleBOx">
               <h2 class="title">
                {{help.name22}}
            </h2>
        </div>
        <div class="content"> 
            <h3>{{help.name24}}</h3>
            <h5 class="tip1">{{help.name25}}</h5>
            <p class="tip2">{{help.name26}}</p>
            <h3 class="tip3">{{help.name27}}</h3>
            <div class="box">
                <div class="list" :class="index == 0 ? 'activity':''"  @click="index = 0">{{help.name28}}</div>
                <div class="list" :class="index == 1 ? 'activity':''" @click="index = 1">{{help.name29}}</div>
                <img loading="lazy" v-lazy="require('../../assets/images/yy/help2.jpg')" alt="" v-show="index == 0" srcset="">
                <img loading="lazy" v-lazy="require('../../assets/images/yy/help1.jpg')" alt="" v-show="index == 1" srcset="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            index:0
        }
    },
    computed: {
        help() {
            return this.$t('help')
        }
    },
    methods:{
    },
    mounted(){

    }
}
</script>
<style scoped lang='scss'>
    .hijackingHelp{
        .titleBOx{
            border-bottom: 2px solid #f0f0f0;
            width: 100%;
            height: 60px;
            .title{
                line-height: 60px;
                margin-left: 30px;
                font-size: 24px;
                font-weight: 200;
                color: #e21;
            }
        }
        .content{
            padding: 30px 30px 50px;
            h3{
                padding: 0px 0px 20px;
                line-height: 30px;
                color: rgb(208, 25, 36);
                font-size: 18px;
                font-weight: 500;
            }
            .tip1{
                font-size: 15px;
                line-height: 40px;
                font-weight: 600;
            }
            .tip2{
                line-height: 32px;
                font-size: 14px;
                color: #666;
                text-indent: 2em;
            }
            .tip3{
                padding: 10px 0px 20px;
                line-height: 40px;
                color: rgb(208, 25, 36);
            }
            .box{
                width: 100%;
                .list{
                    display: inline-block;
                    width: 116px;
                    height: 42px;
                    background: #d9d9d9;
                    color: #000;
                    line-height: 45px;
                    font-size: 14px;
                    overflow: hidden;
                    margin-right: 10px;
                    font-weight: 600;
                    cursor: pointer;
                    text-indent: 0;
                    text-align: center;
                }
                .activity{
                    background: #000;
                    color: #fff;
                }
                img{
                    width: 100%;
                }
            }
        }
    }
</style>